<template>
  <PForm
    ref="pForm"
    :heading="`${
      tradeNameFormState.edit ? 'Edit ' : 'Add new ' + 'trade name'
    }`"
    :primary-cta="addButton"
    @close="closeForm"
    @reset="resetForm"
    @submit.prevent="onSubmit"
  >
    <div class="row q-col-gutter-lg">
      <div class="col-12">
        <PInput
          v-model.trim="formData.name"
          label="Add new trade name to the master list"
          :validations="{ label: 'Trade Name', required: true }"
          placeholder="Enter name such as Udaan etc."
        ></PInput>
      </div>
    </div>
  </PForm>
</template>

<script setup>
import tradeNameFormModel from "src/modules/user/models/tradeNameForm";
import { useUserStore } from "src/stores/user";

const props = defineProps({
  toggle: {
    type: Object,
    default: () => {
      return {
        method: false,
        options: {},
      };
    },
  },
});

const { tradeNameFormState } = storeToRefs(useUserStore());
const { toggleTradeNameForm } = useUserStore();

const pForm = ref(null);

const { formData, closeForm, resetForm } = useForm({
  formModel: tradeNameFormModel(),
  formRef: pForm,
  isForm: tradeNameFormState,
  toggleForm: toggleTradeNameForm,
});

const addButton = computed(() => {
  return {
    label: unref(tradeNameFormState).edit ? "Save" : "Add",
  };
});

const onSubmit = () => {
  if (props.toggle.method) {
    props.toggle.method(unref(formData));

    closeForm(true);
  }
};
</script>
